import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  items: [],
  isLoading: false,
  error: null,
  item: {},
  created: {},
  isLoadingCreated: false,
  bids: [],
  isErrorLoadingBid: false,
  isLoadingBid: false,
  isLoadingBidPrice: false,
  isErrorLoadingBidPrice: false,
  bidPrice: [],

  itemExtend: {},
  isLoadingExtend: false,
  errorExtend: false,

  itemCancel: {},
  isLoadingCancel: false,
  errorCancel: false,

  rfqFilter: {},
  errorRfqFilter: false,
  isLoadingRfqFilter: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/rfq/index.js